module.exports = __webpack_public_path__ + "static/TT2-evergreen-page-screening-sales-eat-iStock-854725372.18d81b5b.jpg";